/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListOwnedMoneyPoolsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {ListOwnedMoneyPoolsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const listOwnedMoneyPools = (request:ListOwnedMoneyPoolsRequest, options?: CashRequestOptions) => post<ListOwnedMoneyPoolsRequest, ListOwnedMoneyPoolsResponse>("/2.0/cash/list-owned-money-pools", request, {...options, rejectOnError: true })